import React, {FC,ReactNode} from 'react'

interface Props {
    children: ReactNode;
}

export const TableBody:FC<Props> = ({children}) => {
  return (
    <tbody>
          {children}
    </tbody>
  )
}


